export const KEYS = ['jilin','shanxi','anhui','jiangsu','hainan','xinjiang','turkey','saudi','france','spain']

// 坐标基于 375px 宽度的设计稿（按原图比例换算为 px）
export const MAP_POSITIONS = {
  china: {
    jilin:   { x: 333, y: 164 },
    shanxi:  { x: 189, y: 254 },
    anhui:   { x: 261, y: 283 },
    jiangsu: { x: 299, y: 259 },
    hainan:  { x: 202, y: 404 },
    xinjiang:{ x: 70,  y: 222 }
  },
  world: {
    turkey:  { x: 258, y: 247 },
    saudi:   { x: 300, y: 353 },
    france:  { x: 105, y: 173 },
    spain:   { x: 50,  y: 237 }
  }
}
